import accents from "remove-accents";

export const removeDiacriticsFromString = (string: string): string =>
  accents.remove(string);
